// Called by the app initializer before the login sequence has checked the stored session. The
// gateway answers a request carrying an expired token with a 401 even on these public endpoints,
// which fails the initializer instead of letting the login sequence send the user to log in.
const PRE_LOGIN_ENDPOINTS = [/\/org\/api\/env$/, /\/org\/api\/org\/code\/[^/]+$/]

export function attachesAccessToken(url: string, baseUrl: string): boolean {
  const path = url.split('?')[0].toLowerCase()

  return (
    path.startsWith(baseUrl.toLowerCase()) &&
    !PRE_LOGIN_ENDPOINTS.some((endpoint) => endpoint.test(path))
  )
}
